import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Register from './pages/Register';
import Wallet from './pages/Wallet';
import WalletDetail from './pages/WalletDetail';
import TopUpReturn from './pages/TopUpReturn';
import Explore from './pages/Explore';
import History from './pages/History';
import Profile from './pages/Profile';
import PrivacyPage from './pages/legal/PrivacyPage';
import TermsPage from './pages/legal/TermsPage';

export default function App() {
  return (
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID ?? ''}>
      <ErrorBoundary>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />

              {/* Private routes */}
              <Route element={<PrivateRoute />}>
                {/* Full-screen detail (no bottom tabs) */}
                <Route path="/wallet/:brandId" element={<WalletDetail />} />

                {/* Redsys online-recharge return routes (UrlOK / UrlKO) — UX only; the
                    S2S notification credits the saldo, these just poll/report it. */}
                <Route path="/topup/ok" element={<TopUpReturn status="ok" />} />
                <Route path="/topup/ko" element={<TopUpReturn status="ko" />} />

                <Route element={<Layout />}>
                  <Route path="/" element={<Navigate to="/wallet" replace />} />
                  <Route path="/wallet" element={<Wallet />} />
                  <Route path="/explore" element={<Explore />} />
                  <Route path="/history" element={<History />} />
                  <Route path="/profile" element={<Profile />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ErrorBoundary>
    </GoogleOAuthProvider>
  );
}

